import React from 'react';
import styled, { keyframes } from 'styled-components';

import FadeInImg from '../FadeInImg';
import breakpoints from '../../util/breakpoints';

const FLOAT_DISTANCE = '20px';

const floatOffset = keyframes`
  0% {
    transform: translateY(${FLOAT_DISTANCE});
  }
  50% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(${FLOAT_DISTANCE});
  }
`;

const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(${FLOAT_DISTANCE});
  }
  100% {
    transform: translateY(0px);
  }
`;

const Person = styled.div`
  position: absolute;
  will-change: transform;
`;

const KatyImage = styled(Person)`
  width: 235px;
  height: 262px;

  top: 60px;
  left: 20px;

  animation: ${floatOffset} 11s ease-in-out infinite;

  ${breakpoints.md`
    top: 120px;
    left: 50px;
  `}

  ${breakpoints.lg`
    width: 360px;
    height: 400px;
  `}

  ${breakpoints.xl`
    width: 450px;
    height: 500px;
  `}
`;

export const NicoImage = styled(Person)`
  width: 250px;
  height: 295px;

  top: 200px;
  right: 20px;

  animation: ${float} 8s ease-in-out infinite;

  ${breakpoints.sm`
    top: 100px;
  `}

  ${breakpoints.md`
    top: 120px;
    right: 50px;
  `}

  ${breakpoints.lg`
    width: 400px;
    height: 468px;
  `}

  ${breakpoints.xl`
    width: 475px;
    height: 555px;
  `}
`;

export const Katy = () => (
  <KatyImage>
    <FadeInImg src="/images/katy.svg" />
  </KatyImage>
);
export const Nico = () => (
  <NicoImage>
    <FadeInImg src="/images/nico.svg" delay="250ms" />
  </NicoImage>
);
export default Person;



// WEBPACK FOOTER //
// ./src/components/ui/Person.js